document.addEventListener('DOMContentLoaded', function () {
	paintBonusStatus(document.querySelector('.custom-progress'))
})

function paintBonusStatus(customProgress) {
	if (customProgress) {
		let value = customProgress.dataset.value
		let breakpoints = customProgress.dataset.breakpoints.split(',')
		let steps = customProgress.querySelector('.steps .bar')
		let status = value / breakpoints[1]
		if (!(status < 1)) {
			customProgress.classList.add("premium");
			steps.style = `background: linear-gradient(90deg, #242424 0% ${status*100}%, #C4C4C4 ${status*100}% 100%)`
		} else if (!(status < 0.5)) {
			customProgress.classList.add("middle");
			steps.style = `background: linear-gradient(90deg, #DA251C 0% ${status*100}%, #C4C4C4 ${status*100}% 100%)`
		} else {
			steps.style = `background: linear-gradient(90deg, #75B861 0% ${status*100}%, #C4C4C4 ${status*100}% 100%)`
		}
	}
}
